<!--<li>-->
<!--  <a routerLink="/" routerLinkActive="active" ariaCurrentWhenActive="page">home</a>-->
<!--</li>-->
<!--<li>-->
<!--  <a routerLink="/reader" routerLinkActive="active" ariaCurrentWhenActive="page">demo</a>-->
<!--</li>-->

<router-outlet />
